import can from "lib/permissions/can";

export default user => can(user)("view:tasks");
